// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  magic: 'http://api-magicframe.moonmusic.top',
  track: 'http://dee.notool.top/api',
  timestamp: 'http://cdn.soundhex.com/api/v1',
  music: 'http://moonmusic.top',
  lyric: 'http://db.moonmusic.top',
  source: 'http://source.moonmusic.top',
  reup: 'http://bas.reupnet.info',
  moonseo: 'https://moonseo.app/api',
  dr360studio: 'https://dr.360studio.vip',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
